import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Text } from "../../../index.js";
export function Title(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({
    color: "inherit",
    fontFamily: "heading",
    lineHeight: "1.14",
    fontWeight: "normal",
    textAlign: "inherit"
  }, props), children);
}